import classes from './WhitePaperCard.module.css';
import cx from 'classnames';
import {BsArrowRightCircle} from 'react-icons/bs'
import { isEmpty } from '../../utils/UtilityFunctions';
import { RxExternalLink } from 'react-icons/rx';

function WhitePaperCard(props) {
    let { containerClass, image, title, itemDetails, onClickHandler, author, date, isBlog,
        profile, isExternalLink} = props;

    const onClickCard = () => {
        if(!isEmpty(onClickHandler)){
            onClickHandler(itemDetails);
        }
    }

    let externalLinkComponent = null;

    if(isExternalLink){
        externalLinkComponent = (
            <span className={cx(['text-center'])} title='View'>
                <RxExternalLink className={cx([classes.ExternalIcon])} size={20} />
            </span>
        )
    }

    return(
        <div className={containerClass}>
            <div className={cx([classes.Card])} onClick={onClickCard}>
                <div className={classes.WhitePaperImageContainer}>
                    <img className={classes.WhitePaperImage} src={image} alt={title} title={title} />
                    <span className={classes.ImageSectionIcons}>
                        {externalLinkComponent}
                    </span>
                </div>
                <div className={cx(['d-flex flex-wrap p-3'])}>
                    <span className={cx(['col-12',classes.Title])} title={title}>
                        {title}
                    </span>
                    <div className={'d-flex align-items-center mt-3'}>
                        { 
                            !isEmpty(profile) && 
                            <div className="flex-shrink-0">
                                <img className={classes.Profile} src={profile} alt="profile" title={author}/>
                            </div>
                        }
                        <div className={cx(["flex-grow-1 ms-3",classes.Info])}>
                            <span className={classes.PersonName}>
                                {author}
                            </span>
                            <span className={classes.Date}>
                                {date}
                            </span>
                        </div>
                    </div>
                    {
                        !isBlog &&
                        <span className={cx(['col-12 text-end'])}>
                            <BsArrowRightCircle size={20} color="var(--color-primary)"/>
                            {/* <img className={classes.IconImage} src={DOWNLOAD_ORANGE} alt={'Download'} title={'Downloadable'}/> */}
                        </span>
                    }
                </div>
            </div>
        </div>
    )
}

export default WhitePaperCard;